import { analyticsEventsTracker, EVENT_TRACKERS, GTMOnboardingFunnelEvent } from "../analytics";
import aes from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';
import { getInternalProductId } from "./getInternalProductId";

interface IProductIds {
  year?: number;
  month?: number;
  week?: number;
  threeMonths?: number;
  sixMonts?: number;
}

function getParameterFromURLForEmail(name) {
  let url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2]);
}

export const getContentIds = (ids: IProductIds) => {
  let emailInputValue;
  const values = Object.values(ids)
  .filter((value): value is number => value !== undefined)
  .map(getInternalProductId);
  const emailInputValueFromUrl = getParameterFromURLForEmail("ev");

  if (emailInputValueFromUrl) {
    let emailInputValueRaw = aes.decrypt(emailInputValueFromUrl, "9213812384");
    emailInputValue = emailInputValueRaw.toString(enc);
  }
  
  analyticsEventsTracker.trackWithTarget(
    GTMOnboardingFunnelEvent.getContentIds(values, emailInputValue), 
    EVENT_TRACKERS.GTM
  );
};